import React, { useRef, useContext, useState } from "react";
import "./device.css";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DeviceSection } from "../../context/DeviceContext";
import QrReader from "react-qr-reader";
import { deviceWidgetsDisjoined } from "../../api";
import { Alert } from "../";
import { setDeviceWidgetsDisjoined } from "../../redux";
import { withRouter } from "react-router-dom";
import { DeviceMineContext } from "../../context/DeviceMineContext";
import { useTranslation } from "react-i18next";
import { FiCamera, FiCheck, FiArrowLeft, FiGrid } from "react-icons/fi";

const ScanDeviceComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const { deviceMine, setDeviceMine } = useContext(DeviceMineContext);
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const [scanResault, setScanResault] = useState(null);
  const formikRef = useRef();
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const initialValues = {
    serial: "",
  };

  const playSuccessSound = () => {
    try {
      const AudioContext = window.AudioContext || window.webkitAudioContext;
      const audioCtx = new AudioContext();
      
      const oscillator1 = audioCtx.createOscillator();
      const gainNode1 = audioCtx.createGain();
      oscillator1.connect(gainNode1);
      gainNode1.connect(audioCtx.destination);
      oscillator1.frequency.value = 880;
      oscillator1.type = "sine";
      gainNode1.gain.value = 0.3;
      oscillator1.start();
      
      setTimeout(() => {
        gainNode1.gain.exponentialRampToValueAtTime(0.00001, audioCtx.currentTime + 0.1);
        oscillator1.stop();
      }, 150);
      
      setTimeout(() => {
        const oscillator2 = audioCtx.createOscillator();
        const gainNode2 = audioCtx.createGain();
        oscillator2.connect(gainNode2);
        gainNode2.connect(audioCtx.destination);
        oscillator2.frequency.value = 880;
        oscillator2.type = "sine";
        gainNode2.gain.value = 0.3;
        oscillator2.start();
        
        setTimeout(() => {
          gainNode2.gain.exponentialRampToValueAtTime(0.00001, audioCtx.currentTime + 0.1);
          oscillator2.stop();
          audioCtx.close();
        }, 150);
      }, 200);
      
    } catch (error) {
      console.log("Audio error:", error);
    }
  };

  const submitForm = () => {
    const formData = new FormData();
    const serial = scanResault || formikRef.current?.values?.serial || "";
    formData.append("serial", serial);
    
    // ✅ درست: استفاده از deviceWidgetsDisjoined برای دریافت ویجت‌های جدا شده
    deviceWidgetsDisjoined(formData, token)
      .then((res) => {
        console.log(res.data.data);
        dispatch(setDeviceWidgetsDisjoined(res.data.data));
        ShowHideDeviceFunction("allDevices");
      })
      .catch((err) => {
        if (err.response?.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else if (err.response?.status === 404) {
          setShowAlert({
            show: true,
            message: t("دستگاهی با این سریال یافت نشد."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 3000);
        } else {
          setShowAlert({
            show: true,
            message: t("خطایی رخ داده است. لطفا مجددا امتحان کنید."),
            type: "Error",
          });
          setTimeout(() => {
            setShowAlert((prev) => ({ ...prev, show: false }));
          }, 3000);
        }
      });
  };

  const validationSchema = Yup.object({
    serial: Yup.string().required(t("سریال دستگاه را وارد کنید")),
  });

  const closeAlert = () => {
    setShowAlert(prev => ({ ...prev, show: false }));
  };

  const handleScan = (result) => {
    if (result) {
      const cleanedResult = result.trim().replace(/\s/g, '');
      playSuccessSound();
      setScanResault(cleanedResult);
      if (formikRef.current) {
        formikRef.current.setFieldValue('serial', cleanedResult);
      }
      setShowAlert({
        show: true,
        message: t("دستگاه با موفقیت اسکن شد"),
        type: "Success",
      });
      setTimeout(() => {
        setShowAlert((prev) => ({ ...prev, show: false }));
      }, 2000);
    }
  };

  return (
    <div className="scan-device-container">
      <div className="scan-device-qr-section">
        <div className="scan-device-qr-wrapper">
          <QrReader
            onError={(err) => console.log(err)}
            onScan={handleScan}
            style={{ width: "100%", height: "100%" }}
            facingMode="environment"
            className="qr-reader-video"
          />
          <div className="scan-device-qr-overlay">
            <FiCamera size={32} />
          </div>
        </div>
      </div>

      <Formik
        initialValues={initialValues}
        onSubmit={submitForm}
        validationSchema={validationSchema}
        innerRef={formikRef}
      >
        {(formProps) => (
          <Form>
            <div className="scan-device-form">
              <div className="setting-item" style={{ flexDirection: "column", alignItems: "stretch", gap: "12px" }}>
                <div className="setting-item-label">
                  <FiGrid size={16} />
                  <span>{t("سریال دستگاه")}</span>
                </div>
                <input
                  type="text"
                  placeholder={t("سریال دستگاه را وارد کنید")}
                  name="serial"
                  className="setting-input"
                  onChange={formProps.handleChange}
                  onBlur={formProps.handleBlur}
                  value={formProps.values.serial || scanResault || ""}
                />
                <ErrorMessage name="serial">
                  {(errMsg) => <div className="setting-error">{errMsg}</div>}
                </ErrorMessage>
              </div>
            </div>

            <div className="setting-buttons">
              <button
                type="button"
                className="setting-back-btn"
                onClick={() => ShowHideDeviceFunction("firstPage")}
                style={{ background: "var(--bg-white)", color: "var(--text-primary)", border: "2px solid var(--border-color)" }}
              >
                <FiArrowLeft size={18} />
                <span>{t("بازگشت")}</span>
              </button>
              <button type="submit" className="setting-back-btn">
                <FiCheck size={18} />
                <span>{t("بعدی")}</span>
              </button>
            </div>
          </Form>
        )}
      </Formik>

      {showAlert.show && (
        <Alert 
          message={showAlert.message} 
          type={showAlert.type}
          toggleAlert={closeAlert}
        />
      )}
    </div>
  );
};

const ScanDevice = withRouter(ScanDeviceComp);

export { ScanDevice };